<template>
    <section>
        <div>
            <div id="filter-toggle">
                <span style="align-self: center">Filtros:</span>
                <i v-if="toggleFilter" id="toggle-show" class="fas fa-eye" @click.prevent="toggleFilter = !toggleFilter" title="Ocultar filtros"></i>
                <i v-else id="toggle-hidden" class="fas fa-eye-slash toggle-icon" @click.prevent="toggleFilter = !toggleFilter" title="Exibir filtros"></i>
                <i id="toggle-show" class="fas fa-arrow-rotate-left" @click.prevent="generateFilters(responseData)" title="Resetar filtros"></i>
            </div>
            <dashboard-filters
                id="filters-component"
                @generateDashboard="dashboardRequest"
                :class="[{'slide-content': fullFilter}, {'hide-filter': !toggleFilter}]"
                :dynamic="dynamic"
                :filters="filters"
                :reset="resetDate"
                @addFilter=""
                @removeFilter=""
                @changeFilters="changeFilters"
            />
            <div v-if="!generateMessage">
                <div v-show="!loading" :class="{'modal-show': modalShow}" class="tables">
                    <div class="table-container" :class="expandTable('bank')">
                        <div class="container-header">
                            <p>Atendimentos por instituição financeira</p>
                            <div class="table-controls">
                                <i v-if='view.bank' class="fas fa-download" title="Baixar tabela" @click.prevent="downloadTable('bank')"></i>
                                <i v-if="view.bank" class="fas fa-chart-pie" title="Visualizar gráfico" @click.prevent="view.bank = !view.bank"></i>
                                <i v-else class="fas fa-table" title="Visualizar tabela" @click.prevent="view.bank = !view.bank"></i>
                                <i class="fas fa-maximize" title="Ampliar" @click="toggleExpand('bank')"></i>
                            </div>
                        </div>
                        <div class="container-body" :class="{'expanded-body': isExpanded.bank}">
                            <dashboard-bank-table v-show="view.bank" :bankData="bankTableData, bankTotal, period" @tableLoaded="tableLoaded"></dashboard-bank-table>
                            <dashboard-bank-chart v-show="!view.bank" :bankData="bankTableData, bankTotal, period" @tableLoaded="tableLoaded"></dashboard-bank-chart>
                        </div>
                    </div>
                    <div class="table-container" :class="expandTable('bankNps')">
                        <div class="container-header">
                            <p>Nível de Satisfação por cliente</p>
                            <div class="table-controls">
                                <i v-if='view.bankNps' class="fas fa-download" title="Baixar tabela" @click.prevent="downloadTable('bankNps')"></i>
                                <i v-if="view.bankNps" class="fas fa-chart-pie" title="Visualizar gráfico" @click.prevent="view.bankNps = !view.bankNps"></i>
                                <i v-else class="fas fa-table" title="Visualizar tabela" @click.prevent="view.bankNps = !view.bankNps"></i>
                                <i class="fas fa-maximize" title="Ampliar" @click="toggleExpand('bankNps')"></i>
                            </div>
                        </div>
                        <div class="container-body" :class="{'expanded-body': isExpanded.bankNps}">
                            <dashboard-bankNps-table v-show="view.bankNps" :bankNpsData="bankNpsTableData, period" @tableLoaded="tableLoaded"></dashboard-bankNps-table>
                            <dashboard-bankNps-chart v-show="!view.bankNps" :bankNpsData="bankNpsTableData, period" @tableLoaded="tableLoaded"></dashboard-bankNps-chart>
                        </div>
                    </div>
                    <div class="table-container" :class="expandTable('queue')">
                        <div class="container-header">
                            <p>Atendimentos por Fila</p>
                            <div class="table-controls">
                                <i v-if='view.queue' class="fas fa-download" title="Baixar tabela" @click.prevent="downloadTable('queue')"></i>
                                <i v-if="view.queue" class="fas fa-chart-pie" title="Visualizar gráfico" @click.prevent="view.queue = !view.queue"></i>
                                <i v-else class="fas fa-table" title="Visualizar tabela" @click.prevent="view.queue = !view.queue"></i>
                                <i class="fas fa-maximize" title="Ampliar" @click="toggleExpand('queue')"></i>
                            </div>
                        </div>
                        <div class="container-body" :class="{'expanded-body': isExpanded.queue}">
                            <dashboard-queue-table v-show="view.queue" :queueData="queueTableData, queueTotal, period, phoneQueuesArray" @tableLoaded="tableLoaded"></dashboard-queue-table>
                            <dashboard-queue-chart v-show="!view.queue" :queueData="queueTableData, queueTotal, period, phoneQueuesArray" @tableLoaded="tableLoaded"></dashboard-queue-chart>
                        </div>
                    </div>
                    <div class="table-container" :class="expandTable('queueMotivation')">
                        <div class="container-header">
                            <p>Motivação por Fila - Chat</p>
                            <div class="table-controls">
                                <i v-if='view.queue' class="fas fa-download" title="Baixar tabela" @click.prevent="downloadTable('queueMotivation')"></i>
                                <i v-if="view.queueMotivation" class="fas fa-chart-pie" title="Visualizar gráfico" @click.prevent="view.queueMotivation = !view.queueMotivation"></i>
                                <i v-else class="fas fa-table" title="Visualizar tabela" @click.prevent="view.queueMotivation = !view.queueMotivation"></i>
                                <i class="fas fa-maximize" title="Ampliar" @click="toggleExpand('queueMotivation')"></i>
                            </div>
                        </div>
                        <div class="container-body" :class="{'expanded-body': isExpanded.queueMotivation}">
                            <dashboard-queueMotivation-table v-show="view.queueMotivation" :queueMotivationData="queueMotivationTableData, period, phoneQueuesArray" @tableLoaded="tableLoaded"></dashboard-queueMotivation-table>
                            <dashboard-queueMotivation-chart v-show="!view.queueMotivation" :queueMotivationData="queueMotivationTableData, period, phoneQueuesArray" @tableLoaded="tableLoaded"></dashboard-queueMotivation-chart>
                        </div>
                    </div>
                </div>
                <div class="generate-message" v-show="loading">
                    <span><i class="fas fa-spinner fa-pulse"></i>   Carregando...</span>
                </div>
            </div>
            <div v-else class="generate-message">
                <span>⬆️  Selecione o período desejado acima e gere seu Dashboard</span>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return {
                toggleFilter: true,
                fullFilter: false,
                dynamic: false,
                resetDate: true,
                period: '',
                bankTableData: {},
                bankTotal: {},
                queueTableData: {},
                queueTotal: {},
                queueMotivationTableData: {},
                bankNpsTableData: {},
                bankNpsTotal: {},
                responseData: {},
                filteredData: {},
                download: false,
                isExpanded: {
                    bank: false,
                    queue: false,
                    queueMotivation: false,
                    bankNps: false
                },
                modalShow: false,
                loading: false,
                loaded: {
                    bankTable: false,
                    queueTable: false,
                    queueMotivationTable: false,
                    bankNpsTable: false,
                },
                generateMessage: true,
                phoneQueuesArray: [],
                filters: {
                    channels: [],
                    subjects: [],
                    motivations: [],
                    banks: [],
                    chatQueues: [],
                    phoneQueues: [],
                },
                view: {
                    bank: true,
                    queue: true,
                    queueMotivation: true,
                    bankNps: true
                },
            }
        },
        methods:{
            tableLoaded(table){
                this.loaded[table] = true;
            },

            downloadTable(table){
                if(table){
                    this.$root.$emit('download', table)
                }
            },

            async dashboardRequest(filterData){
                this.generateMessage = false;
                this.loading = true;
                this.dynamic = false;
                this.fullFilter = false;
                this.view = {
                    bank: true,
                    queue: true,
                    queueMotivation: true,
                    bankNps: true
                }
                this.responseData = []
                await axios.get('/dashboard/getData', {params: filterData.params}).then(({data}) => {
                    if(data){
                        this.filteredData = []
                        if(Object.entries(data).length > 0){
                            Object.entries(data).forEach(el => {
                                this.responseData[el[0]] = [];
                                this.filteredData[el[0]] = [];
                                Object.entries(el[1]).forEach(obj => {
                                    this.responseData[el[0]].push(obj[1]);
                                    this.filteredData[el[0]].push(obj[1]);
                                })
                            })
                        }
                    }
                })
                this.period = filterData.period;
                await this.generateFilters(this.responseData);
                await this.generateTables(this.filteredData);
            },

            toggleExpand(table){
                this.modalShow = !this.modalShow;
                this.isExpanded[table] = !this.isExpanded[table]
            },

            expandTable(table){
                const hasTrue = Object.values(this.isExpanded).some(value => value === true);
                if(hasTrue){
                    if(this.isExpanded[table]){
                        return 'expanded';
                    } else {
                        return 'invisible';
                    }
                }
                return '';
            },

            async generateFilters(data){
                let dynFilters = {
                    channels: [],
                    subjects: [],
                    motivations: [],
                    banks: [],
                    chatQueues: [],
                    phoneQueues: [],
                }
                Object.values(data).forEach(dataObj => {
                    Object.values(dataObj).forEach(obj => {
                        if(obj.channel && !dynFilters.channels.some(el => obj.channel === el.value)){
                            if(obj.channel == 'wppChat'){
                                dynFilters.channels.push({value: obj.channel, label: 'Whatsapp'});
                            } else if(obj.channel == 'telefonia'){
                                dynFilters.channels.push({value: obj.channel, label: 'Telefone'});
                            } else {
                                dynFilters.channels.push({value: obj.channel, label: 'Webchat'});
                            }
                        }
                        
                        if(obj.subject && !dynFilters.subjects.some(el => obj.subject === el.value)){
                            dynFilters.subjects.push({value: obj.subject, label: obj.subject});
                        } else if(!obj.subject && !dynFilters.subjects.some(el => 'Não identificado' === el.label)){
                            dynFilters.subjects.push({value: '', label: 'Não identificado'});
                        }

                        if(obj.reason && !dynFilters.motivations.some(el => obj.reason === el.value)){
                            dynFilters.motivations.push({value: obj.reason, label: obj.reason});
                        } else if(!obj.reason && !dynFilters.motivations.some(el => 'Não informado' === el.label)){
                            dynFilters.motivations.push({value: '', label: 'Não informado'});
                        }

                        if(obj.instituicao_financeira && !dynFilters.banks.some(el => obj.instituicao_financeira === el.value)){
                            if(obj.instituicao_financeira.length > 25){
                                const label = obj.instituicao_financeira.substring(0, 25) + '...'
                                dynFilters.banks.push({value: obj.instituicao_financeira, label: label});
                            } else {
                                dynFilters.banks.push({value: obj.instituicao_financeira, label: obj.instituicao_financeira});
                            }
                        } else if(!obj.instituicao_financeira && !dynFilters.banks.some(el => 'Não identificado' === el.label)){
                            dynFilters.banks.push({value: '', label: 'Não identificado'});
                        }

                        if(obj.queue && !this.phoneQueuesArray.includes(obj.queue) && obj.queue != 'Atendimento Ativo'){
                            if(obj.queue.includes(' - ')){
                                let subst = obj.queue.split(' - ');
                                obj.queue = subst[1];
                            }
                            if(!dynFilters.chatQueues.some(el => obj.queue === el.value)){
                                let label = '';
                                if(obj.queue.length > 25){
                                    label = obj.queue.substring(0, 25) + '...'
                                } else {
                                    if(obj.queue == 'generica'){
                                        label = 'Atendimento na URA';
                                    } else if(obj.queue == 'entrante'){
                                        label = 'Atendimento Ativo';
                                    } else {
                                        label = obj.queue;
                                    }
                                }
                                dynFilters.chatQueues.push({value: obj.queue, label: label});
                            }
                        } else if(obj.queue && (this.phoneQueuesArray.includes(obj.queue) || obj.queue == 'Atendimento Ativo')) {
                            if(obj.queue.includes('-')){
                                const arr = obj.queue.split('-');
                                if(['eagro', 'bradesco', 'itau', 'poupex'].includes(arr[0])){
                                    const index = obj.queue.indexOf('-');
                                    obj.queue = obj.queue.substring(index + 1)
                                }
                            }
                            if(!dynFilters.phoneQueues.some(el => obj.queue === el.value)){
                                let label = '';
                                if(obj.queue == 'Atendimento Ativo'){
                                    label = 'Ligação Sainte';
                                } else {
                                    if(obj.queue.length > 25){
                                        label = obj.queue.substring(0, 25) + '...'
                                    } else {
                                        label = obj.queue;
                                    }
                                }
                                dynFilters.phoneQueues.push({value: obj.queue, label: label});
                            }
                        }
                    })
                })
                this.filters = dynFilters;
            },

            async generateTables(data){
                await this.generateBankTable(data);
                await this.generateQueueTable(data);
                await this.generateQueueMotivationTable(data);
                await this.generateBankNpsTable(data);
            },
            
            async reloadTables(data){
                await this.generateBankTable(data);
                await this.generateQueueTable(data);
                await this.generateQueueMotivationTable(data);
                await this.generateBankNpsTable(data);
            },

            async generateBankTable(data){
                this.bankTableData = {};
                this.loaded.bankTable = false;
                this.bankTotal = {};
                //Não usar o data. Usar um objeto filtrado
                for (const mes in data) {
                    const instituicoes = {};
                    const valores = data[mes];
                    // let naoIdentificado = 0;
                    this.bankTotal[mes] = 0;

                    for (const chave in valores) {
                        const instituicao = valores[chave].instituicao_financeira;

                        if (instituicao) {
                            if (instituicoes[instituicao]) {
                                instituicoes[instituicao]++;
                            } else {
                                instituicoes[instituicao] = 1;
                            }
                        } else {
                            if (instituicoes['Não identificado']) {
                                instituicoes['Não identificado']++;
                            } else {
                                instituicoes['Não identificado'] = 1;
                            }
                        }

                        this.bankTotal[mes]++;
                    }

                    this.bankTableData[mes] = instituicoes;
                }
            },

            async generateQueueTable(data){
                this.queueTableData = {};
                this.loaded.queueTable = false;
                this.queueTotal = {};
                //Não usar o data. Usar um objeto filtrado
                for (const mes in data) {
                    const queues = {};
                    const valores = data[mes];
                    this.queueTotal[mes] = 0;

                    for (const chave in valores) {
                        const queue = valores[chave].queue;
                        let queueGroup = '';


                        if (queue) {
                            if(queue.includes(' - ')){
                                let strArray = queue.split(' - ');
                                queueGroup = strArray[1];
                            } else {
                                if(queue.includes('-')){
                                    const arr = queue.split('-');
                                    if(['eagro', 'bradesco', 'itau', 'poupex'].includes(arr[0])){
                                        const index = queue.indexOf('-');
                                        queueGroup = queue.substring(index + 1)
                                    } else {
                                        queueGroup = queue;
                                    }
                                } else {
                                    if(queue == 'entrante'){
                                        queueGroup = 'Atendimento Ativo';
                                    } else if(queue == 'Atendimento Ativo'){
                                        queueGroup = 'Ligação Sainte';
                                    } else if(queue == 'generica'){
                                        queueGroup = 'Atendimento na URA';
                                    } else {
                                        queueGroup = queue;
                                    }
                                }
                            }               

                            if(queue == 'Nota Devolutiva') queueGroup = 'Notas Devolutivas';

                            if (queues[queueGroup]) {
                                queues[queueGroup]++;
                            } else {
                                queues[queueGroup] = 1;
                            }

                            this.queueTotal[mes]++;
                        }
                    }

                    this.queueTableData[mes] = queues;
                }
            },

            async generateQueueMotivationTable(data){
                this.queueMotivationTableData = {};
                this.loaded.queueMotivationTable = false;
                //Não usar o data. Usar um objeto filtrado
                const queues = {};
                for (const mes in data) {
                    const valores = data[mes];

                    for (const chave in valores) {
                        const queue = valores[chave].queue;
                        let subject = valores[chave].subject
                        let queueGroup = '';

                        if(queue && !this.phoneQueuesArray.includes(queue) && queue != 'Atendimento Ativo' && queue != 'entrante'){
                            if(queue.includes(' - ')){
                                let strArray = queue.split(' - ');
                                queueGroup = strArray[1];
                            } else if(queue == 'generica'){
                                queueGroup = 'Atendimento na URA';
                            } else {
                                queueGroup = queue;
                            }

                            if(queue == 'Nota Devolutiva') queueGroup = 'Notas Devolutivas';
                            
                            if(!queues[queueGroup]) {
                                queues[queueGroup] = {
                                    'naoinformado': 0,
                                    'acompanhamento': 0,
                                    'duvidas': 0,
                                    'inatividade': 0,
                                    'outros': 0,
                                    'total': 0
                                }
                            };

                            if(subject.toLowerCase().includes('acompanhamento')){
                                subject = 'acompanhamento';
                            } else if(subject.toLowerCase().includes('dúvidas')){
                                subject = 'duvidas';
                            } else if(subject.toLowerCase().includes('outros')){
                                subject = 'outros';
                            } else if(subject.toLowerCase().includes('inatividade')){
                                subject = 'inatividade';
                            } else {
                                subject = 'naoinformado';
                            }

                            if(queues[queueGroup]){
                                queues[queueGroup][subject]++;
                                queues[queueGroup]['total']++;
                            }
                        }
                    }
                }

                this.queueMotivationTableData = queues;
            },

            async generateBankNpsTable(data){
                this.bankNpsTableData = {};
                this.loaded.bankNpsTable = false;
                //Não usar o data. Usar um objeto filtrado
                const avaliacoes = {}
                for (const mes in data) {
                    const valores = data[mes];

                    for (const chave in valores) {
                        let instituicao = valores[chave].instituicao_financeira;
                        const nota = valores[chave].grade

                        if(!instituicao) instituicao = 'Não identificado';

                        if(!avaliacoes[instituicao]){
                            avaliacoes[instituicao] = {
                                'naoavaliado': 0,
                                'pessimo': 0,
                                'ruim': 0,
                                'regular': 0,
                                'bom': 0,
                                'otimo': 0,
                                'total': 0,
                                'nps': ''
                            }
                        }
                        
                        if(nota == 5){
                            avaliacoes[instituicao]['otimo']++;   
                            avaliacoes[instituicao]['total']++;
                        } else if(nota == 4){
                            avaliacoes[instituicao]['bom']++;
                            avaliacoes[instituicao]['total']++;
                        } else if(nota == 3){
                            avaliacoes[instituicao]['regular']++;
                            avaliacoes[instituicao]['total']++;
                        } else if(nota == 2){
                            avaliacoes[instituicao]['ruim']++;
                            avaliacoes[instituicao]['total']++;
                        } else if(nota == 1){
                            avaliacoes[instituicao]['pessimo']++;
                            avaliacoes[instituicao]['total']++;
                        } else {
                            avaliacoes[instituicao]['naoavaliado']++;
                        }
                    }
                }
                this.bankNpsTableData = avaliacoes;
            },
            changeFilters(data){
                const filters = data.filters;

                //Concatenação das filas de chat e telefonia na propriedade queue
                let newFilters = {};
                const queues = filters['queue'].concat(filters['chatQueue']);
                Object.entries(filters).forEach(el => {
                    if(!el[0].toLowerCase().includes('queue')) newFilters[el[0]] = el[1]
                })
                newFilters['queue'] = queues

                let filtered = this.filteredData;
                Object.entries(this.responseData).forEach(id => {
                    filtered[id[0]] = [];
                    filtered[id[0]] = id[1].filter(att => {
                        let check = [];
                        Object.entries(newFilters).forEach(filter => {
                            if(filter[1].includes(att[filter[0]])){
                                check.push(true);
                            } else {
                                check.push(false);
                            }  
                        })
                        if(check.some(value => value === false)){
                            return false;
                        } else {
                            return att;
                        }

                    })
                })
                this.filteredData = {};
                this.filteredData = filtered;
            },
            
        },
        mounted(){
            axios.get('listQueue').then(({data}) => {
                if(data){
                    data.forEach(el => {
                        this.phoneQueuesArray.push(el.name);
                    })
                }
            })
        },
        watch: {
            loaded: {
                deep: true,
                handler(newVal) {
                    const hasFalseValue = Object.values(newVal).some(value => value === false);

                    if(!hasFalseValue) {
                        // Não há nenhum valor false
                        this.fullFilter = true;
                        this.dynamic = true;
                        this.loading = false;
                    } else {
                        this.loading = true;
                    }
                }
            },
            filteredData: {
                deep: true,
                handler(newVal){
                    this.reloadTables(newVal)
                }
            },
        }
    }
</script>

<style scoped>
#filters-component {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 70;
    transition: 0.5s;
    top: -12;
    z-index: 5;
    width: 100%;
    left: 0;
}

#filter-toggle{
    display: flex;
    font-size: small;
    font-weight: bold;
    position: relative;
    right: 0;
    top: -10;
    z-index: 20;
    justify-content: flex-end;
    background-color: #679ea9;
    padding-right: 10px;
}

#toggle-show{
    cursor: pointer;
    color: #1c869a;
    font-size: large;
    margin: 5px;
    align-self: center;
}

#toggle-show:hover{
    color: #155b69;
    transition: 0.3s;
}

#toggle-hidden{
    cursor: pointer;
    color: lightgray;
    font-size: large;
    margin: 5px;
    align-self: center;
}

#toggle-hidden:hover{
    color: rgb(139, 139, 139);
    transition: 0.3s;
}

.table-container{
    border: 2px solid black;
    width: 48vw;
    margin: 5px;
}

.modal-show{
    justify-content: space-evenly;
    flex-wrap: wrap;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(8px);
    z-index: 9999;
    display: flex;
    align-items: center;
    transition: 0.3s;
}

.container-body{
    overflow: auto;
    max-height: 400px;
    min-height: 400px;
}

.expanded{
    width: 98vw !important;
    /* max-height: 90vh; */
    position: absolute;
    z-index: 5;
}

.expanded-body{
    max-height: 90vh;
    background-color: white;
}

.tables{
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
}

.slide-content{
    height: 260 !important;
}

.hide-filter{
    top: -300px !important;
    transition: ease-out 1s;
    height: 0 !important;
}

@media (max-width: 534px) {
    #filters-component{
        height: 60;
    }
    .slide-content{
        height: 310 !important;
    }

    .hide-filter{
       top: -360 !important;
       height: 0 !important;
    }
}

.container-body::-webkit-scrollbar {
  height: 12px !important;
}

.container-body::-webkit-scrollbar-thumb {
  background-color: #1c869a;
  border-radius: 5px !important;
}

.container-header{
    display: flex;
    justify-content: space-between;
    background-color: #1c869a;
}

.container-header p{
    font-size: large;
    font-weight: bold;
    color: white;
    margin: 0 10px;

}

.table-controls{
    display: flex;
    margin-right: 5px;
}
.table-controls i{
    font-size: larger;
    margin: 3px;
    cursor: pointer;
    color: white;
    align-self: center;
}

.table-controls i:hover{
    color: #145d6c;
    transition: 0.3s;
}

.generate-message {
    display: flex;
    justify-content: center;
    font-size: x-large;
    color: #1c869a;
    font-weight: bold;
}

</style>